export enum GaEvents {
  START_REGISTRATION = 'start_registration',
  ACTIVATE_SUBSCRIPTION = 'activate_subscription',
  CANCEL_SUBSCRIPTION = 'cancel_subscription',
  REACTIVATE_SUBSCRIPTION = 'reactivate_subscription',
  CHANGE_PLAN = 'change_plan',
  MARKETING_EVENT = 'marketing_event',

  // App
  OPEN_PAGE_MENU = 'open_page_menu',
  OPEN_SITE = 'open_site',
  SELECT_STORE = 'select_store',
  SELECT_PLACE = 'select_place',
  SEND_WHATS_APP = 'send_whats_app',
  SEND_EMAIL = 'send_email',
  SEE_WHATS_NEWS = 'see_whats_news',

  PRINT_ORDER = 'print_order',
  SHARE_PDF_ORDER = 'share_pdf_order',

  // Tips
  SEE_TIPS = 'see_tips',
  SELECT_ITEM_TIPS = 'select_item_tips',
  SELECT_TIP_AS_USEFUL = 'select_tip_as_useful',
  SELECT_TIP_AS_USELESS = 'select_tip_as_useless',

  // Help
  SELECT_QUESTION = 'select_question',
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/ga-events.enum.ts